import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class BlogStore {
  blogConfiguration = {};

  currentPost = {};

  posts = [];

  categories = [];

  constructor(initialData) {
    makeAutoObservable(this);
    // Ensure arrays are actually arrays (defensive check)
    // Handle both empty initialData (404/500 pages) and malformed data
    if (initialData) {
      this.posts = Array.isArray(initialData.posts) ? initialData.posts : [];
      this.currentPost = initialData.currentPost || {};
      this.categories = Array.isArray(initialData.categories)
        ? initialData.categories
        : [];
    }
  }

  setPosts = (posts) => {
    this.posts = posts;
  };

  setCategories = (categories) => {
    this.categories = categories;
  };

  setCurrentPost = (currentPost) => {
    this.currentPost = currentPost;
  };

  setBlogConfiguration = (blogConfiguration) => {
    this.blogConfiguration = blogConfiguration;
  };
}

export default BlogStore;
